<rt-dialog-header
  [heading]="translationKey.authenticationForm.authentication | translate"
  class="has-actions"
>
  <rt-icon-button
    class="dialog-close"
    variant="plain"
    iconName="close"
    size="small"
    (click)="closeDialog()"
  />
</rt-dialog-header>

<rt-dialog-body variant="white" layout-vertical>
  <div class="dialog-content">
    <div layout-horizontal>
      <div class="admin-box" layout layout-align-items-center margin-bottom-small>
        <rt-avatar
          [type]="user.hasAvatar ? 'image' : 'initials'"
          [size]="'base'"
          [shape]="'oval'"
          [initials]="user.initials"
          [imageSrc]="user.photoThumbUrl"
          [fullName]="fullName"
          [isColorized]="colorizedAvatar"
          margin-small
          context="admin"
        ></rt-avatar>
        <div class="text" layout-vertical>
          <rt-heading>{{ user.firstName }} {{ user.lastName }}</rt-heading>
          <span>{{ user.email }}</span>
        </div>
      </div>
    </div>

    <div margin-bottom-small>
      {{ translationKey.authenticationForm.toContinueVerify | translate }}
    </div>

    @if (VerificationType.EMAIL_CODE === selectedVerification) {
      <rt-form-field margin-bottom-small>
        <rt-label>
          {{ translationKey.authenticationForm.emailVerificationCode | translate }}
        </rt-label>
        <rt-code-input
          [rtFormError]="errorMessages.emailCode"
          [formControl]="authenticationForm.controls.emailCode"
        ></rt-code-input>
      </rt-form-field>
      <div>
        <div layout layout-align-items-center>
          @if (canChangeVerificationType) {
            <rt-button
              (click)="onVerificationTypeChange(VerificationType.PASSWORD)"
              variant="plain"
            >
              {{ translationKey.authenticationForm.usePassword | translate }}
            </rt-button>

            <span margin-small> {{ translationKey.common.or | translate }} </span>
          }

          <rt-button (click)="requestEmailCode()" variant="plain">
            {{ translationKey.authenticationForm.resendCode | translate }}
          </rt-button>
        </div>
      </div>
    } @else {
      <rt-form-field margin-bottom>
        <rt-label>
          {{ translationKey.authenticationForm.currentPassword | translate }}
        </rt-label>
        <div class="input-wrap">
          <rt-input
            variant="rounded"
            [type]="inputType"
            [autoFocus]="true"
            [formControl]="authenticationForm.controls.password"
            [rtFormError]="errorMessages.password"
            [disabled]="passwordUsageDisabled"
          >
          </rt-input>
          @if (passwordUsageDisabled) {
            <rt-infobox [isDismissible]="false" [iconName]="'info-outline'" margin-top-small>{{
              translationKey.authenticationForm.ssoEnabledInfobox | translate
            }}</rt-infobox>
          }
          <rt-icon-button
            (click)="toggleVisibility()"
            variant="plain"
            class="visibility-btn"
            [iconName]="visibilityIcon"
            shape="square"
          >
          </rt-icon-button>
        </div>
      </rt-form-field>
      <div layout>
        @if (canChangeVerificationType) {
          <rt-button
            (click)="onVerificationTypeChange(VerificationType.EMAIL_CODE)"
            variant="plain"
          >
            {{ translationKey.authenticationForm.useVerificationCode | translate }}
          </rt-button>
        }
      </div>
    }
  </div>
</rt-dialog-body>
<rt-dialog-footer innerPadding="medium" variant="white" class="buttons-container">
  <rt-button (click)="closeDialog()" variant="plain">
    {{ translationKey.common.cancel | translate }}
  </rt-button>
  <rt-button
    (click)="submit()"
    [loading]="isLoading"
    [disabled]="
      authenticationForm.invalid ||
      (passwordUsageDisabled && selectedVerification === VerificationType.PASSWORD)
    "
    variant="primary"
  >
    {{ translationKey.common.continue | translate }}
  </rt-button>
</rt-dialog-footer>
